import {
  type inferQueryKeyStore,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'

import { codenamesLibraryQueries } from '~/features/codenames-library/common/queries'
import { familiesQueries } from '~/features/families/common/queries/family.queries'
import { announcementsQueries } from '~/queries/announcements-queries'
import { draftQueries } from '~/queries/drafts-queries'
import { indicatorsQueries } from '~/queries/indicators-queries'
import { languagesQueries } from '~/queries/languages'
import { librariesQueries } from '~/queries/libraries'
import { mapsQueries } from '~/queries/maps'
import { organizationQueries } from '~/queries/organizations'
import { projectsQueries } from '~/queries/projects'
import { reportsQueries } from '~/queries/reports'
import { solutionsQueries } from '~/queries/solutions'
import { surveysQueries } from '~/queries/surveys-queries'
import { userQueries } from '~/queries/users'

export const queries = mergeQueryKeys(
  familiesQueries,
  organizationQueries,
  solutionsQueries,
  mapsQueries,
  projectsQueries,
  languagesQueries,
  reportsQueries,
  librariesQueries,
  userQueries,
  surveysQueries,
  draftQueries,
  announcementsQueries,
  indicatorsQueries,
  codenamesLibraryQueries,
)

export type Queries = inferQueryKeyStore<typeof queries>
